import React from 'react';
import Img from 'img';
import Container from 'container';
import s from './ad-b.module.scss';

export default function AdA({ image, href, ...props }) {
  return (
    <Container className={s.root}>
      <div className={s.wrapper}>
        <a href={href} className={s.link}>
          <div className={s.imgWrapper}>
            <Img className={s.img} src={image} alt={image.title} />
          </div>
        </a>
      </div>
    </Container>
  );
}
